import { useMutation } from '@tanstack/react-query';
import { EditUserAccountAdminJson, EditUserJson } from '../types';
import { usersRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';

export const useUpdateUser = () =>
  useMutation<ApiResponse<unknown>, unknown, EditUserJson>((user) =>
    usersRepo.updateUser(user),
  );

export const useUpdateUserAccountAdmin = () =>
  useMutation<ApiResponse<unknown>, unknown, EditUserAccountAdminJson>((user) =>
    usersRepo.updateAccountAdmin(user),
  );
